import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { doesNodeContainClick } from 'semantic-ui-react/dist/commonjs/lib';
import { useIntl, defineMessages, injectIntl } from 'react-intl';
import cx from 'classnames';
import { getBaseUrl, hasApiExpander } from '@plone/volto/helpers';
import config from '@plone/volto/registry';
import { getNavigation } from '@plone/volto/actions';
import { Icon } from '@plone/volto/components';
import rightArrow from '@plone/volto/icons/right-key.svg';

const messages = defineMessages({
  closeMenu: {
    id: 'Close menu',
    defaultMessage: 'Close menu',
  },
  openFatMenu: {
    id: 'Open menu',
    defaultMessage: 'Open menu',
  },
});

const Navigation = ({ pathname }) => {
  const [desktopMenuOpen, setDesktopMenuOpen] = useState(null);
  const [currentOpenIndex, setCurrentOpenIndex] = useState(null);
  const navigation = useRef(null);
  const dispatch = useDispatch();
  const intl = useIntl();
  let enableFatMenu = config.settings.enableFatMenu;
  enableFatMenu = false;

  const lang = useSelector((state) => state.intl.locale);
  const token = useSelector((state) => state.userSession.token, shallowEqual);
  const items = useSelector((state) => state.navigation.items, shallowEqual);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navigation.current && doesNodeContainClick(navigation.current, e))
        return;
      closeMenu();
    };

    document.addEventListener('mousedown', handleClickOutside, false);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, false);
    };
  }, []);

  useEffect(() => {
    if (!hasApiExpander('navigation', getBaseUrl(pathname))) {
      dispatch(getNavigation(getBaseUrl(pathname), config.settings.navDepth));
    }
  }, [pathname, token, dispatch]);

  const isActive = (url) => {
    return (url === '' && pathname === '/') || (url !== '' && pathname === url);
  };

  /* const openMenu = (index) => {
    if (index === currentOpenIndex) {
      closeMenu();
    } else {
      setDesktopMenuOpen(index);
      setCurrentOpenIndex(index);
    }
  }; */

  const closeMenu = () => {
    setDesktopMenuOpen(null);
    setCurrentOpenIndex(null);
  };

  const handleItemClick = (item, index) => {
    if (item.items && item.items.length > 0) {
      //instead of open menu, go to link
      //openMenu(index);
      window.location.href = item.url === '' ? '/' : item.url;
    } else {
      //closeMenu();
      window.location.href = item.url === '' ? '/' : item.url;
    }
  };

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        //closeMenu();
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);

  return (
    <nav
      id="navigation"
      aria-label="navigation"
      className="navigation"
      ref={navigation}
    >
      <div className={'computer large screen widescreen only'}>
        <ul className="desktop-menu">
          {items.map((item, index) => (
            <div className="hover-menu" key={index}>
              <li>
                {item.items && item.items.length > 0 && (
                  <Icon
                    style={{
                      marginTop: '12px',
                      marginLeft: '-20px',
                      display: 'flex',
                      position: 'absolute',
                    }}
                    name={rightArrow}
                    size="20px"
                  />
                )}
                <button
                  onClick={() => handleItemClick(item, index)}
                  className={cx('item', {
                    active:
                      desktopMenuOpen === index ||
                      (!desktopMenuOpen && pathname === item.url),
                  })}
                  aria-label={intl.formatMessage(messages.openFatMenu)}
                  aria-expanded={desktopMenuOpen === index ? true : false}
                >
                  {item.title.toUpperCase()}
                </button>

                {item.items && item.items.length > 0 && (
                  <div
                    className={cx('submenu', {
                      active: desktopMenuOpen === index,
                    })}
                  >
                    <div className="submenu-inner">
                      <button
                        style={{ display: 'block' }}
                        className="close"
                        onClick={closeMenu}
                        aria-label={intl.formatMessage(messages.closeMenu)}
                      ></button>
                      <ul>
                        {item.items.map((subitem, index) => (
                          <li className="subitem-wrapper" key={index}>
                            <NavLink
                              to={subitem.url}
                              onClick={() => closeMenu()}
                              className={cx({
                                current: isActive(subitem.url),
                              })}
                            >
                              {subitem.nav_title || subitem.title}
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </li>
            </div>
          ))}
        </ul>
      </div>
    </nav>
  );
};

Navigation.propTypes = {
  pathname: PropTypes.string.isRequired,
};

Navigation.defaultProps = {
  token: null,
};

export default injectIntl(Navigation);
